import { BuiltCampaignControllerTrigger } from "./BuiltCampaignControllerTrigger";
export class BuiltCampaignControllerTriggerShare extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
    }
}
